export function CheckIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
    return (
        <svg aria-hidden='true' viewBox='8 8 16 16' fill='currentColor' {...props}>
            <path d='M11.83 15.795a1 1 0 0 0-1.66 1.114l1.66-1.114Zm9.861-4.072a1 1 0 1 0-1.382-1.446l1.382 1.446ZM14.115 21l-.83.557a1 1 0 0 0 1.784-.258L14.115 21Zm.954.3c1.29-4.11 3.539-6.63 6.622-9.577l-1.382-1.446c-3.152 3.013-5.704 5.82-7.148 10.424l1.908.598Zm-4.9-4.391 3.115 4.648 1.661-1.114-3.114-4.648-1.662 1.114Z' />
        </svg>
    );
}
